import {z} from "zod/v4-mini"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {
    pointGeometryAttributeSetLike,
    pointGeometryAttributeSetLikeMarker,
    curveGeometryAttributeSetLike,
    meshGeometryAttributeSetLike,
} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {pointGeometryAttributeLike, curveGeometryAttributeLike, meshGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {
    PointGeometryAttributeLikeNode,
    CurveGeometryAttributeLikeNode,
    MeshGeometryAttributeLikeNode,
} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {
    PointGeometryAttributeSetLikeNode,
    CurveGeometryAttributeSetLikeNode,
    MeshGeometryAttributeSetLikeNode,
} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {JoinOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/join-operator/geometry-join-operator-node"
import {GeometryJoinOperatorNode, joinOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute-set/join-operator/geometry-join-operator-node"

export type PointGeometryJoinOperatorParameters = JoinOperatorParameters<
    PointGeometryAttributeLikeNode,
    PointGeometryAttributeSetLikeNode,
    CurveGeometryAttributeLikeNode | MeshGeometryAttributeLikeNode,
    CurveGeometryAttributeSetLikeNode | MeshGeometryAttributeSetLikeNode
>

const definition: TemplateNodeDefinition<PointGeometryJoinOperatorParameters> = {
    nodeClass: "PointGeometryJoinOperator",
    validation: {
        parameters: joinOperatorParametersSchema(
            pointGeometryAttributeLike,
            pointGeometryAttributeSetLike,
            z.union([curveGeometryAttributeLike, meshGeometryAttributeLike]),
            z.union([curveGeometryAttributeSetLike, meshGeometryAttributeSetLike]),
        ),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryJoinOperator
    extends GeometryJoinOperatorNode<
        0,
        PointGeometryAttributeLikeNode,
        PointGeometryAttributeSetLikeNode,
        CurveGeometryAttributeLikeNode | MeshGeometryAttributeLikeNode,
        CurveGeometryAttributeSetLikeNode | MeshGeometryAttributeSetLikeNode
    >
    implements PointGeometryAttributeSetLikeNode
{
    get [pointGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }

    protected override get outputIndexingDim(): 0 {
        return 0
    }
}
